export const formatRows = (listaItems) =>
  listaItems.map((item) => ({
    id: item.id || "Id no disponible",
    ac_id_padre: item.ac_id_padre|| "Articulo Referencia No Disponible",
    ac_id_hijo: item.ac_id_hijo|| "Articulo Combo no disponible",
    ac_codigo_hijo: item.ac_codigo_hijo|| "Codigo no disponible",
    art_descripcion: item.Contenido_combo_hijo.art_descripcion|| "Descripcion no disponible",
    ac_cantidad: item.ac_cantidad || "Cantidad no disponible",
  }));
